var module = angular.module('octopusApp.configuration');

module.controller('DiagnosticsLogsController', function($scope, busy, octopusRepository, pollLoop) {
  var isLoading = $scope.isLoading = busy.create();
  $scope.refresh = function() {
    return isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function (status) {
      return isLoading.promise(octopusRepository.ServerStatus.getLogs(status).then(function (logs) {
        $scope.logs = logs;
      }));
    }));
  };

  $scope.refresh();
});









//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/diagnostics/controllers/diagnostics_logs_controller.js
// module id = 386
// module chunks = 1